<template>
    <div class="allContentWrap">
        <div class="orderDetailBox"  >
            <!-- 基础信息 -->
            <div class="detailBox" >
                <div class="orderNumBox">
                    <span>订单号：</span>
                    <span>{{orderInfo.order_number}}</span>
                    <span :class="{red:orderInfo.orderState=='1',green:orderInfo.orderState=='2',orange_lighter:orderInfo.orderState=='3'}">
                        {{ orderInfo.orderState|turnValToText('order_pay_status')}}
                    </span>
                </div>
                <el-row class="smallFont">
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">创建时间：</span>
                            <span class="text">{{orderInfo.orderTime}}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="itemBox">
                            <span class="label">确认付款时间：</span>
                            <span class="text">{{orderInfo.paymentTime}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div class="itemBox">
                            <span class="label">发票抬头：</span>
                            <span class="text">{{orderInfo.order_invoice_title}}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div class="itemBox">
                            <span class="label">买家留言：</span>
                            <span class="text">{{orderInfo.order_memo}}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <!-- 品牌展示 -->
            <div class="panelBlock" v-for="(list1,index1) in productGroups" :key="index1">
                <div class="panelTitle">
                    <span>{{list1.brandName}}</span>
                </div>
                <div class="panelContent">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <div class="orderItem">
                                <div class="left">
                                    <img :src="IMG_PREV+list1.imageFile" alt="" class="picImg">
                                </div>
                                <div class="right">
                                    <div class="title"> {{list1.itemName}}</div>
                                    <div class="des">
                                        <div class="itemSpan">
                                            <span class="label">款号：</span>
                                            <span class="text">{{list1.styleNumber}}</span>
                                        </div>
                                        <div class="itemSpan">
                                            <span class="label">颜色：</span>
                                            <span class="text">{{list1.colorName}}</span>
                                        </div>
                                        <div class="itemSpan">
                                            <span class="label">数量：</span>
                                            <span class="text">{{list1.totalNum}}件</span>
                                        </div>
        
                                    </div>
                                    <div class="des">
                                        <div class="itemSpan underline">
                                            <span class="label">吊牌价：</span>
                                            <span class="text">¥{{list1.originalPric}}</span>
                                        </div>
                                        <div class="itemSpan">
                                            <span class="label">订货价：</span>
                                            <span class="text">¥{{list1.orderPrice}}</span>
                                        </div>
                                        <div class="itemSpan">
                                            <span class="label">小计：</span>
                                            <span class="text">¥{{list1.totalPrice}}</span>
                                        </div>
                                    </div>
                                    <div class="smallTable">
                                        <div class="size first">
                                            <span v-for="list2 in list1.orderDetailInfo3">{{list2.sizeName}}</span>
                                        </div>
                                        <div class="size two">
                                            <span v-for="list2 in list1.orderDetailInfo3">{{list2.cart_quantity}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="totalBox">
                <div class="itemBox">
                    <span class="label">共计:</span>
                    <span class="text">{{orderInfo.order_total_quantity}}件</span>
                </div>
                <div class="itemBox">
                    <span class="label">合计: </span>
                    <span class="text">{{orderInfo.order_total_amount}}元</span>
                </div>
            </div>
            <div class="addressBox">
                <div class="title">收货人信息</div>
                <div>
                    <span>{{buyerInfo.buyerName}}</span>
                    <span>{{buyerInfo.buyerPhone}}</span>
                    <span>{{buyerInfo.buyerCompany}}</span>
                </div>
                <div>{{buyerInfo.buyerAdd}}</div>
            </div>
            
        </div>
        
        <div class="buttonBox">
            <el-button type="primary" size="mini"  @click="openPrintModal" >打印</el-button>
            <el-button type="primary" size="mini" v-if="orderInfo.orderState==1&&functionConfirmReceivedMoney" @click="checkReceiveMoney">确认收款</el-button>
        </div>
        <el-dialog      title="打印"      :visible.sync="isShowPrintModal"    >
              <div class="printModalContent" id="printDiv">
                  <div class="orderDetailBox relativeBox"  >
                      <!-- 基础信息 -->
                      <div class="detailBox" >
                          <div class="erweimaBox">
                              <vue-qr :text="String(orderInfo.order_number) " :size="100"></vue-qr>
                              <div>订单二维码</div>
                          </div>
                          <div class="orderNumBox">
                              <span>订单号：</span>
                              <span>{{orderInfo.order_number}}</span>
                              <span :class="{red:orderInfo.orderState=='1',green:orderInfo.orderState=='2',orange_lighter:orderInfo.orderState=='3'}">
                                  {{ orderInfo.orderState|turnValToText('order_pay_status')}}
                              </span>
                          </div>
                          <el-row>
                              <el-col :span="24">
                                  <div class="itemBox">
                                      <span class="label">发票抬头：</span>
                                      <span class="text">{{orderInfo.order_invoice_title}}</span>
                                  </div>
                              </el-col>
                          </el-row>
                          <el-row :span="24">
                              <el-col>
                                  <div class="itemBox">
                                      <span class="label">买家留言：</span>
                                      <span class="text">{{orderInfo.order_memo}}</span>
                                  </div>
                              </el-col>
                          </el-row>
                          <el-row class="smallFont">
                              <el-col :span="24">
                                  <div class="itemBox">
                                      <span class="label">创建时间：</span>
                                      <span class="text">{{orderInfo.orderTime}}</span>
                                  </div>
                              </el-col>
                              <el-col :span="24">
                                  <div class="itemBox">
                                      <span class="label">确认付款时间：</span>
                                      <span class="text">{{orderInfo.paymentTime}}</span>
                                  </div>
                              </el-col>
                          </el-row>
                          
                      </div>
                      <div class="dottedBlock">
                          <div class="title">收货人信息</div>
                          <div class="content">
                              <div>
                                  <span class="label">姓名：</span><span>{{buyerInfo.buyerName}}</span>
                              </div>
                              <div>
                                  <span class="label">手机：</span><span>{{buyerInfo.buyerPhone}}</span>
                              </div>
                              <div>
                                  <span class="label">地址：</span><span>{{buyerInfo.buyerAdd}} </span>
                              </div>
                          </div>
                      </div>
                      <div class="dottedBlock">
                          <div class="title">客户信息</div>
                          <div class="content">
                              <div>
                                  <span class="label">姓名：</span><span>{{buyerInfo.ces}}</span>
                              </div>
                              <div>
                                  <span class="label">账号：</span><span>{{buyerInfo.customerPhone}}</span>
                              </div>
                              <div>
                                  <span class="label">公司：</span><span> {{buyerInfo.buyerCompany}}</span>
                              </div>
                          </div>
                      </div>
                      <div class="dottedBlock">
                          <div class="title">付款信息</div>
                          <div class="content">
                              <div>
                                  <span class="label">付款方式：</span><span>{{buyerInfo.paymentMethod |turnValToText("pay_methods")}}</span>
                              </div>
                              <div>
                                  <span class="label">流水号：</span><span>{{buyerInfo.paymentSn}}</span>
                              </div>
                              <div>
                                  <span class="label">付款时间：</span><span> {{buyerInfo.paymentTime}}</span>
                              </div>
                          </div>
                      </div>
                      <!-- 品牌展示 -->
                      <div class="panelBlock" v-for="(list1,index1) in productGroups" :key="index1">
                          <div class="panelTitle">
                              <span>品牌:{{list1.brandName}}</span>
                          </div>
                          <div class="panelContent">
                              <el-row :gutter="10">
                                  <el-col :span="20">
                                      <div class="orderItem">
                                          <div class="left">
                                              <img :src="IMG_PREV+list1.imageFile" alt="" class="picImg">
                                          </div>
                                          <div class="right">
                                              <div class="title"> {{list1.itemName}}</div>
                                              <div class="des">
                                                  <div class="itemSpan">
                                                      <span class="label">款号：</span>
                                                      <span class="text">{{list1.styleNumber}}</span>
                                                  </div>
                                                  <div class="itemSpan">
                                                      <span class="label">颜色：</span>
                                                      <span class="text">{{list1.colorName}}</span>
                                                  </div>
                                                  <div class="itemSpan">
                                                      <span class="label">数量：</span>
                                                      <span class="text">{{list1.totalNum}}件</span>
                                                  </div>
                  
                                              </div>
                                              <div class="des">
                                                  <div class="itemSpan underline">
                                                      <span class="label">吊牌价：</span>
                                                      <span class="text">¥{{list1.originalPric}}</span>
                                                  </div>
                                                  <div class="itemSpan">
                                                      <span class="label">订货价：</span>
                                                      <span class="text">¥{{list1.orderPrice}}</span>
                                                  </div>
                                                  <div class="itemSpan">
                                                      <span class="label">小计：</span>
                                                      <span class="text">¥{{list1.totalPrice}}</span>
                                                  </div>
                                              </div>
                                              <div class="smallTable">
                                                  <div class="size first">
                                                      <span v-for="list2 in list1.orderDetailInfo3">{{list2.sizeName}}</span>
                                                  </div>
                                                  <div class="size two">
                                                      <span v-for="list2 in list1.orderDetailInfo3">{{list2.cart_quantity}}</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </el-col>
                              </el-row>
                          </div>
                      </div>
                      <div class="totalBox">
                          <div class="itemBox">
                              <span class="label">共计:</span>
                              <span class="text">{{orderInfo.order_total_quantity}}件</span>
                          </div>
                          <div class="itemBox">
                              <span class="label">合计: </span>
                              <span class="text">{{orderInfo.order_total_amount}}元</span>
                          </div>
                      </div>
                      
                      
                  </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="isShowPrintModal = false">关闭</el-button>
                <el-button type="primary" v-print="'#printDiv'">打印</el-button>
              </span>
        </el-dialog>
    </div>
    
</template>

<script>
    import VueQr from 'vue-qr'
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        api
    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                isShowPrintModal:false,
                isLoading: false,
                conferenceId: '',
                orderNumber: '',
                orderInfo: {},
                buyerInfo: {},
                productGroups: []
            }
        },
        components: {VueQr},
        computed: {
            functionConfirmReceivedMoney(){
                return utils.getCurrentFunction().indexOf("confirmReceivedMoney")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },

        },
        methods: {
            openPrintModal(){
                let _this=this
                this.isShowPrintModal = true

            },
            refreshPage() {
                this.getDetail()
            },
            checkReceiveMoney(list) {
                let _this = this
                if (!confirm("确认该订单已收款吗？")) {
                    return false
                }
                let arg = {
                    orderNumber: _this.orderNumber
                }
                ajaxPost('/admin/confirmPay', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "确认收款成功",
                            type: 'success',
                            duration: 1500
                        });
                        _this.refreshPage()
                    }
                }, function(res) {

                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                this.orderNumber = this.$route.params.orderNumber
            },
            getDetail() {
                let _this = this
                let arg = {
                    conferenceId: _this.conferenceId,
                    orderNumber: _this.orderNumber
                }
                ajaxPost('/admin/getOrdersDetail', arg).then(function(res) {
                    _this.orderInfo = {
                        orderState: res.data.orderState,
                        orderTime: res.data.orderTime,
                        order_invoice_title: res.data.order_invoice_title,
                        order_memo: res.data.order_memo,
                        order_number: res.data.order_number,
                        order_total_amount: res.data.order_total_amount,
                        order_total_quantity: res.data.order_total_quantity,
                        paymentTime: res.data.paymentTime
                    }

                    _this.buyerInfo = res.data
                    _this.productGroups = res.data.orderDetailInfo2 ? res.data.orderDetailInfo2 : []
                    
                }, function(res) {

                })
            },
        },
        mounted() {
            this.getParams()
            this.getDetail()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid #ddd;;}
    .orderDetailBox {

        padding: 10px;

        .underline {
            text-decoration: line-through;
        }

        .detailBox {
            margin-bottom: 20px;

            .el-row {
                padding: 2px 0;
            }

            .orderNumBox {
                font-weight: bold;

                span {
                    margin-right: 10px;
                }
            }

            .smallFont {
                font-size: 12px;
                padding: 5px 0;
                padding-bottom: 10px;
            }
        }

        .panelBlock {
            .el-col {
                margin-bottom: 10px;
            }

            .panelTitle {
                padding: 10px 10px 5px; font-weight: bold;
            }

            .panelContent {
                .orderItem {
                    background: #fff;
                    display: flex;
                    padding: 15px;

                    .left {
                        width: 100px;
                        border: 1px solid #eee;
                        background: #eee;

                        .picImg {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }

                    .right {
                        flex: 1;
                        padding-left: 10px;

                        .title {
                            margin-bottom: 5px;
                        }

                        .des {
                            color: #666;
                            display: flex;
                            font-size: 12px;
                            ;
                            margin-bottom: 2px;

                            .itemSpan {
                                flex: 1;
                            }
                        }

                        .smallTable {
                            margin-top: 6px;

                            .size {
                                display: flex;

                                span {
                                    flex: 1;
                                    border: 1px solid #999;
                                    text-align: center;
                                    border-right: 0;
                                }

                                span:last-child {
                                    border: 1px solid #999;
                                }
                            }

                            .size.first {
                                span {
                                    border-bottom: 0;
                                }
                            }

                            .size.two {}
                        }
                    }
                }
            }

        }

        .totalBox {
            padding: 20px;
            background: #fff;
            margin-top: 10px;

            .itemBox {
                display: inline-block;
                margin-right: 30px;

                .label {
                    margin-right: 10px;
                }
            }
        }

        .addressBox {
            margin-top: 10px;
            padding-left: 20px;
            color: #666;

            span {
                margin-right: 10px;
            }

            .title {
                margin-bottom: 5px;
                color: #000
            }
        }

      

    }
    .allContentWrap{
        padding:10px;
        .buttonBox {
            padding: 20px;
        
            .el-button {
                margin-right: 20px;
            }
        }
        .printModalContent{
            border:1px solid #eee;
            
        }
        
    } 
    .dottedBlock{ 
        border:1px dotted #aaa; width: 600px; margin-bottom: 10px;
        padding:5px;
        .title{font-weight: bold;}
        .content{
            
            .label{display: inline-block;width:80px;}
        }
    }
    .relativeBox{position: relative}
    .erweimaBox{ text-align: center;
        width: 140px;height: 140px; position: absolute;top:0px;right:10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/detail.vue